import React, {useState} from 'react';

import ButtonActions from './buttonActions';

import {useNavigate, useParams} from 'react-router-dom';
import ChartSection from './chartSection';
import CountDown from './countDown';
import MainCardSwitcher from 'components/mainCards';

import DotsLoading from 'components/loadings/dotsLoading';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
interface MyAdvertismentDetailProps {
  app: 'farm' | 'wholesaler';
}

const MyAdvertismentDetail = ({app}: MyAdvertismentDetailProps) => {
  const {guid} = useParams();

  const [isOpenEndModal, setisOpenEndModal] = useState(false);
  const [chosedSugestionUser, setChosedSugestionUser] =
    useState<IChosedSugestionUser>({
      profile: null,
      isOpenModal: false,
      type: null,
      guid: null,
      isDelete: false,
    });
  const {productDetail, isLoading} = useGetPostDetail(guid || '');

  const navigate = useNavigate();

  return (
    <>
      {isLoading ? (
        <DotsLoading />
      ) : (
        <div className="flex w-full flex-col gap-10 px-4 mt-6   py-4">
          <button
            className="w-full flex justify-center "
            onClick={() =>
              navigate(`/${app}/${productDetail?.type}/${guid}`, {
                state: {
                  guid: guid,
                },
              })
            }
          >
            <MainCardSwitcher
              subtype={productDetail?.type || ''}
              type={productDetail?.post_type || ''}
              post={{
                isExpired:
                  productDetail?.[productDetail.type]?.is_expired || false,
                isSold: productDetail?.sale_status?.is_saled || false,
                title: productDetail?.title || '',
                image: productDetail?.main_image?.image,
                created_at: productDetail?.created_at || '',
                state: productDetail?.state ? productDetail.state.name : '',
                city: productDetail?.city ? productDetail?.city.name : '',
                grade: productDetail?.grade ? productDetail?.grade : '',
                price: productDetail?.price || 0,
                expire_date:
                  productDetail?.[productDetail?.type]?.expire_date || '',
                size: productDetail?.cultivation?.area || 0,
                proposal: productDetail?.suggestions || 0,
                negotiated_price: productDetail?.negotiated_price,
              }}
            />
          </button>
          {productDetail && productDetail?.type !== 'simple' && (
            <CountDown
              is_saled={
                productDetail?.sale_status?.is_saled
                  ? productDetail?.sale_status?.is_saled
                  : false
              }
              isOpenEndModal={isOpenEndModal}
              guid={guid ? guid : ''}
              app={app}
              post={productDetail}
              chosedSugestionUser={chosedSugestionUser}
              setisOpenEndModal={setisOpenEndModal}
              setChosedSugestionUser={setChosedSugestionUser}
            />
          )}
          <ChartSection
            postType={productDetail?.type || ''}
            app={app}
            guid={guid ? guid : ''}
          />
          <ButtonActions
            is_saled={
              productDetail?.sale_status?.is_saled
                ? productDetail?.sale_status?.is_saled
                : false
            }
            isExpired={productDetail?.[productDetail?.type]?.is_expired}
            type={productDetail?.post_type || ''}
            postType={productDetail?.type || ''}
            guid={guid ? guid : ''}
            app={app}
            chosedSugestionUser={chosedSugestionUser}
            setisOpenEndModal={setisOpenEndModal}
            setChosedSugestionUser={setChosedSugestionUser}
          />
        </div>
      )}
    </>
  );
};

export default MyAdvertismentDetail;
